import { cartApi } from '~js/utils/cart-api';
import { getDisplayPrice } from '~js/utils/utils';

const cartCountElement = document.getElementById('cart-item-count');
export const updateCartCount = (cartItemCount) => {
  if (cartCountElement) {
    cartCountElement.textContent = cartItemCount > 99 ? '99+' : cartItemCount;
  }
};

export const fetchRecommendationsForCart = async (lineItems, cartConfig) => {
  const latestItem = lineItems.find(
    (item) => item.properties?._is_free_gift !== 'true',
  );

  if (!latestItem?.product_id) {
    return null;
  }

  const fetchUrl = `/recommendations/products.json?product_id=${latestItem.product_id}&intent=${cartConfig.recommendations_intent}&limit=${cartConfig.recommendations_count}`;

  try {
    const response = await fetch(fetchUrl);
    if (!response.ok) {
      throw new Error('Failed to fetch recommendations');
    }

    const data = await response.json();
    return data.products; // Return the recommendations
  } catch (error) {
    console.error('Error fetching recommendations:', error);
    return null;
  }
};

export const getRecommendedProducts = async (lineItems, cartConfig) => {
  if (!cartConfig.show_recommendations) {
    return null;
  }

  let recommendationProducts = null;
  let checkCartItems = true;

  if (cartConfig.recommendations_collection_products?.length) {
    recommendationProducts = cartConfig.recommendations_collection_products;
  } else if (lineItems.length) {
    recommendationProducts = await fetchRecommendationsForCart(
      lineItems,
      cartConfig,
    );
    checkCartItems = false; // No need to check Cart items as the Shopify Recommendation API auto filters it
  } else {
    return null;
  }

  let recommendationsCount = 0;

  const curatedRecommendationProducts = recommendationProducts
    ?.filter((singleProduct) => {
      if (!singleProduct.available) {
        return false;
      }

      // Skip the product if it's already in the Cart
      if (
        checkCartItems &&
        lineItems?.some((lineItem) => lineItem.product_id === singleProduct.id)
      ) {
        return false;
      }

      return true;
    })
    .map((singleProduct) => {
      if (recommendationsCount >= cartConfig.recommendations_count) {
        return null; // Stop mapping more products once the count is reached
      }

      const availableVariant = singleProduct.variants.find(
        (variant) => variant.available,
      );

      if (
        cartConfig.limit_free_gift &&
        String(availableVariant.id) ===
          String(cartConfig.free_gift_available_variant_id)
      ) {
        return null;
      }

      recommendationsCount++;

      return {
        id: singleProduct.id,
        title: singleProduct.title,
        featured_image: singleProduct.featured_image,
        description: singleProduct.description,
        variant: {
          id: availableVariant.id,
          title: availableVariant.title,
          price: availableVariant.price,
          featured_image: availableVariant.featured_image,
          url: `/products/${singleProduct.handle}?variant=${availableVariant.id}`,
        },
      };
    })
    .filter(Boolean); // Remove any null values

  return curatedRecommendationProducts;
};

export const getProgressBarDetails = (cartState, cartConfig) => {
  const freeShippingAmount = Math.max(
    0,
    cartConfig.checkpoint_1_amount - cartState.subtotalVal,
  );
  const freeGiftAmount = Math.max(
    0,
    cartConfig.checkpoint_2_amount - cartState.subtotalVal,
  );
  const progressPercentage = Math.min(
    100,
    (cartState.subtotalVal / cartConfig.checkpoint_2_amount) * 100,
  );
  const freeShippingPosition = Math.min(
    100,
    (cartConfig.checkpoint_1_amount / cartConfig.checkpoint_2_amount) * 100,
  );

  let promotionText = '';
  const hasFreeShipping =
    cartState.subtotalVal >= cartConfig.checkpoint_1_amount;
  const hasFreeGift = cartState.subtotalVal >= cartConfig.checkpoint_2_amount;

  if (hasFreeGift) {
    promotionText = cartConfig.promo_3_text;
  } else if (hasFreeShipping) {
    promotionText = cartConfig.promo_2_text.replace(
      '[amount]',
      getDisplayPrice(freeGiftAmount, false),
    );
  } else {
    promotionText = cartConfig.promo_1_text.replace(
      '[amount]',
      getDisplayPrice(freeShippingAmount, false),
    );
  }

  return {
    promotionText,
    progressPercentage,
    freeShippingPosition,
    hasFreeShipping,
    hasFreeGift,
  };
};

export const handleFreeGift = (cartState, cartConfig, setShowconfettiSpray) => {
  if (
    cartConfig.offer_free_gift &&
    !cartConfig.free_gift_available_variant_id
  ) {
    console.log('Free gift variant is not available.');
  }

  const isEligibleForFreeGift =
    cartConfig.offer_free_gift &&
    cartConfig.free_gift_available_variant_id &&
    cartState.subtotalVal >= cartConfig.checkpoint_2_amount;
  const isFreeGiftInCart = cartState.lineItems.some(
    (item) => item.properties && item.properties._is_free_gift === 'true',
  );

  if (isEligibleForFreeGift && !isFreeGiftInCart) {
    setShowconfettiSpray(true);
    cartApi.addFreeGift(cartConfig.free_gift_available_variant_id);
  } else if (!isEligibleForFreeGift && isFreeGiftInCart) {
    cartApi.removeFreeGift(cartState.lineItems);
  }
};

export const toggleSellingPlan = (checked, item, setLoading) => {
  const sellingPlanId = checked ? item.selling_plans[0]?.id : null;

  cartApi.updateSellingPlan(sellingPlanId, item.key, item.quantity, setLoading);
};
